import React, { useEffect, useState, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const VerifyEmail: React.FC = () => {
  const { verifyEmail } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [error, setError] = useState('');
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    if (!token) {
      setStatus('error');
      setError('Invalid or missing verification link.');
      return;
    }

    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        setError(err.response?.data?.detail || 'This verification link is invalid or has expired.');
      });
  }, [location, verifyEmail]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Incord</h1>
      <div className="auth-container">
        <h2>Verify Your Email</h2>

        {status === 'verifying' && <p>Verifying your email address...</p>}
        {status === 'success' && (
          <p style={{ color: 'green' }}>Your email address has been verified. Thank you!</p>
        )}
        {status === 'error' && <p style={{ color: 'red' }}>{error}</p>}

        <p style={{ marginTop: '20px' }}>
          Back to <Link to="/dashboard">Dashboard</Link>
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
